export default __webpack_public_path__ + "static/media/logo-ecommerce.60b1cc42.png";